import React, { useEffect, useState } from "react";
import { TreeSelect,message } from "antd";
import { useSelector } from "react-redux";

const SteamTreeSelectCustom = ({
  label,
  data, 
  idKey,  
  nameKey,
  valueKey, 
  selectedValues,
  onSelect,
}) => {
  const [internalSelectedValues, setInternalSelectedValues] = useState(selectedValues);

  console.log(label,data)
  const treeData = data?.map((item) => ({
    key: item[idKey]?.toString(),
    title: item[nameKey],
    value: item[valueKey],
  }));


 
  useEffect(() => {
    setInternalSelectedValues(selectedValues);
  }, [data, selectedValues]);

  const handleChange = (values) => {
    // if (values.length > 4) {
    //   message.warning('You can only select 4 parameters.');
    //   return;
    // }

    setInternalSelectedValues(values);
    onSelect(values);
  };

  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  return (
    <div className="flex items-center">
      <label className="pr-3 w-32 text-left">{label || ''}</label>
      <TreeSelect 
        mode="multiple"
        placeholder={`Select ${label || ''}`}
        treeData={treeData}
        maxTagCount={2}
        treeCheckable={true}
        className={` ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
        dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
        onChange={handleChange}
        value={internalSelectedValues}
      />
      
    </div>
  );
};

export default SteamTreeSelectCustom;
